/* MGH 30/09/2026 — barra de portes grátis: atualiza todas as barras [data-mgh-fsb] quando o carrinho muda. */
(function () {
  if (window.mghFsbInit) return;
  window.mghFsbInit = true;

  var fmt = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' });

  function render(totalCents, itemCount) {
    document.querySelectorAll('[data-mgh-fsb]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10) || 14900;
      var remaining = threshold - totalCents;
      var pct = Math.min(100, Math.max(0, Math.floor((totalCents * 100) / threshold)));
      var text = el.querySelector('[data-mgh-fsb-text]');
      var fill = el.querySelector('[data-mgh-fsb-fill]');
      var track = el.querySelector('[data-mgh-fsb-track]');

      el.hidden = itemCount === 0;

      if (remaining > 0) {
        text.innerHTML = 'Faltam <strong>' + fmt.format(remaining / 100) + '</strong> para teres portes grátis 🚚';
        el.classList.remove('is-complete');
      } else {
        text.innerHTML = '<strong>Tens portes grátis!</strong> 🎉';
        el.classList.add('is-complete');
      }

      fill.style.width = pct + '%';
      track.setAttribute('aria-valuenow', pct);
    });
  }

  function refresh() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        render(cart.total_price, cart.item_count);
      })
      .catch(function () {});
  }

  function init() {
    var first = document.querySelector('[data-mgh-fsb]');
    if (first) render(parseInt(first.dataset.total, 10) || 0, parseInt(first.dataset.count, 10) || 0);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }

    // Voltar atrás no browser (bfcache) mostra a página antiga: recarrega o total
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
